<div class="container">
  <app-titulo>Pagamento</app-titulo>
  <form [formGroup]="form">
    <app-input
      type="select"
      label="Forma de pagamento"
      placeholder="Selecione"
      name="NU_TIPO_PGMT"
      formControlName="NU_TIPO_PGMT"
      [selectData]="pagamentoOptions"
      (ngModelChange)="onChangePagamento($event)"
      [requiredInput]="true"
    >
    </app-input>
    <div class="valor-input">
      <app-input
        type="money"
        label="Digite o valor"
        name="VL_PGMT_SAID"
        formControlName="VL_PGMT_SAID"
        [requiredInput]="true"
      >
      </app-input>
      <add-button
        *ngIf="
          this.form.controls['NU_TIPO_PGMT'].value &&
          this.form.controls['VL_PGMT_SAID'].value
        "
        (click)="addPagamento()"
      />
    </div>
    <app-input
      type="money"
      label="Acréscimo"
      name="VL_ACRM"
      formControlName="VL_ACRM"
    >
    </app-input>
    <app-input
      type="money"
      label="Desconto"
      name="VL_DSCT"
      formControlName="VL_DSCT"
    >
    </app-input>
  </form>
  <div *ngIf="ServicoPagamentoTipoValor.length > 0">
    <h3>Pagamentos Adicionados:</h3>
    <ul>
      <li
        *ngFor="
          let pagamento of ServicoPagamentoTipoValor.controls;
          let i = index
        "
        class="pagamento"
      >
        {{ pagamento.get('NM_TIPO_PGMT')?.value }} -
        {{
          pagamento.get('VL_PGMT_SAID')?.value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
        }}
        <button class="action-button" (click)="removePagamento(i)">
          <img src="assets/delete-icon.svg" alt="Remover" />
        </button>
      </li>
    </ul>
  </div>
  <div class="buttons">
    <span></span>
    <div class="total-restante">
      <p>
        Total:
        {{
          form.controls['VL_TOTL'].value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
        }}
      </p>
      <p>
        Restante:
        {{
          form.controls['VL_REST'].value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
        }}
      </p>
    </div>
    <app-botao
      text="Cancelar"
      bgColor="#B91C1C"
      (click)="onCancelar()"
    ></app-botao>
    <app-botao
      text="Confirmar"
      [bgColor]="disableConfirmar() ? '#d1d5db' : '#059669'"
      (click)="onConfirmar()"
      [disabled]="disableConfirmar()"
    ></app-botao>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
